module.exports = __webpack_public_path__ + "static/img/h5-show-phone-player2x.25886ec7.png";